var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EFF1F2",
    width: 32,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.667V8h4v12.333a1 1 0 01-1 1h-6a1 1 0 01-1-1v-9.666h4zM18.667 16h-5.334v2.667h5.334V16zM16 5.333V8h-4V5.333h4zm4-2.666v2.666h-4V2.667h4zM16 0v2.667h-4V0h4z",
    fill: "#ACB3BE"
  }))));
};

export default __webpack_public_path__ + "48a8183ee5fd5ab6350ecac8a17e3356.svg";
export { SvgZip as ReactComponent };